<template>
  <div class="d-flex">
    <div class="flex-fill">
      <div class="card m-1">
        <social-media-overview-chart v-bind:social-data="linkedInData" v-bind:background="'#2867B2'" />
      </div>
    </div>
    <div class="flex-fill">
      <div class="card m-1">
        <social-media-overview-chart v-bind:social-data="twitterData" v-bind:background="'#1DA1F2'" />
      </div>
    </div>
    <div class="flex-fill">
      <div class="card m-1">
        <social-media-overview-chart v-bind:social-data="podcastData" v-bind:background="'#26C281'" />
      </div>
    </div>
    <div class="flex-fill">
      <div class="card m-1">
        <social-media-overview-chart v-bind:social-data="mailchimpData" v-bind:background="'#FFB61E'" />
      </div>
    </div>
    <div class="flex-fill">
      <div class="card m-1">
        <social-media-overview-chart v-bind:social-data="youtubeData" v-bind:background="'#CF000F'" />
      </div>
    </div>
  </div>
</template>

<script>
import SocialMediaOverviewChart from '../tools/charts/SocialMediaOverviewChart'
export default {
  name: '',
  props: ['socialStatistics'],
  components: {SocialMediaOverviewChart},
  computed: {
    linkedInData () {
      return this.socialStatistics.linkedin
    },
    twitterData () {
      return this.socialStatistics.twitter
    },
    podcastData () {
      return this.socialStatistics.podcast
    },
    mailchimpData () {
      return this.socialStatistics.mailchimp
    },
    youtubeData () {
      return this.socialStatistics.youtube
    }
  },
  mounted () {
    console.log(this.socialStatistics)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/homePage/SocialMediaDashboard.vue